import theme from '../Theme';

const styles = (materialTheme) => ({
  takeoutBackground: {
    border: `1px solid ${theme.colors.blue310}`,
    borderRadius: '16px',
    height: '136px',
    background: theme.colors.white12,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  takeoutHeading: {
    display: 'flex',
    justifyContent: 'center',
    color: materialTheme.palette.secondary.main,
    fontWeight: theme.font.weight.semibold,
    fontSize: theme.font.size.md,
    lineHeight: theme.font.lineHeight.md,
  },
  takeoutSubHeading: {
    padding: '0px 7%',
    color: theme.colors.blue120,
    fontWeight: theme.font.weight.light,
    fontSize: theme.font.size.md,
    lineHeight: theme.font.lineHeight.md,
    display: 'flex',
    justifyContent: 'center',
  },
  iconCenter: {
    display: 'flex',
    justifyContent: 'center',
    lineHeight: theme.font.lineHeight.md,
  },
});

export default styles;
